"use client";

import { TinaMarkdown } from "@/lib/utils";

const components = {
  p: ({ children }) => <>{children}</>,
  h1: ({ children }) => <>{children}</>,
  h2: ({ children }) => <>{children}</>,
  h3: ({ children }) => <>{children}</>,
  h4: ({ children }) => <>{children}</>,
  bold: ({ children }) => <span className="text-primary">{children}</span>,
};

export default function HighlightTitle({ content, as: Tag = "h2", ...props }) {
  if (!content) return null;

  // Fallback for plain strings (backward compatibility)
  if (typeof content === "string") {
    return <Tag {...props}>{content}</Tag>;
  }

  return (
    <Tag {...props}>
      <TinaMarkdown content={content} components={components} />
    </Tag>
  );
}
